import React, { useMemo } from "react";
import {
  CompetitionGroup,
  ID,
  TournamentParticipant,
} from "../../../../types";
import { Button } from "../../Button";


interface GroupParticipantsModalProps {
  open: boolean;
  group: CompetitionGroup | null;
  participants: TournamentParticipant[];
  selectedParticipantIds: ID[];
  selectableParticipantIds: Set<ID>;
  saving: boolean;
  onClose: () => void;
  onToggleParticipant: (participantId: ID) => void;
  onReset: () => void;
  onConfirm: () => Promise<void>;
}

export const GroupParticipantsModal: React.FC<GroupParticipantsModalProps> = ({
  open,
  group,
  participants,
  selectedParticipantIds,
  selectableParticipantIds,
  saving,
  onClose,
  onToggleParticipant,
  onReset,
  onConfirm,
}) => {
  const selectedSet = useMemo(
    () => new Set(selectedParticipantIds),
    [selectedParticipantIds]
  );

  if (!open || !group) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50">
      <div className="bg-white rounded-t-xl w-full max-w-2xl p-6 animate-slideUp max-h-[90vh] flex flex-col">

        <div className="mb-4 space-y-2">
          <div className="flex justify-between">
              <h3 className="text-lg font-bold">Modifica partecipanti</h3>
              <span className="text-sm text-gray-600 mt-1">
                {group.name}
              </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">Partecipanti dello stage</span>
            <span className="text-sm text-gray-600">Selezionati: {selectedParticipantIds.length}</span>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto">
          <div className="space-y-2">
            {participants.map((participant) => {
              const isSelectable = selectableParticipantIds.has(participant.id);
              return (
                <label
                  key={participant.id}
                  className={`flex items-center gap-2 rounded border border-gray-300 px-3 py-2 text-sm ${
                    isSelectable ? "bg-white" : "bg-gray-100 text-gray-400"
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={selectedSet.has(participant.id)}
                    onChange={() => onToggleParticipant(participant.id)}
                    disabled={!isSelectable || saving}
                  />
                  <span>{participant.name}</span>
                </label>
              );
            })}
          </div>
        </div>


        <div className="flex justify-between space-x-2 mt-4">
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Annulla
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            disabled={saving || selectedParticipantIds.length < 2}
          >
            {saving ? "Salvataggio..." : "Salva"}
          </Button>
        </div>
      </div>
    </div>
  );
};
